import styled from 'styled-components';

export const AppWrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    height: 100%;
`
